import * as yup from 'yup';
import {
  initialValuesStepOne,
  initialTouchedStepOne,
} from './steps/One/validations';
import {
  initialValuesStepTwo,
  initialTouchedStepTwo,
} from './steps/Two/validations';
import {
  initialValuesStepThree,
  initialTouchedStepThree,
} from './steps/Three/validations';

export const initialValues = {
  ...initialValuesStepOne,
  ...initialValuesStepTwo,
  ...initialValuesStepThree,
};

export const initialTouched = {
  ...initialTouchedStepOne,
  ...initialTouchedStepTwo,
  ...initialTouchedStepThree,
};

const reset = {
  nombre: '',
  telefono: '',
  delivery: '',
  level: '',
  access: '',
  calle: '',
  numeroExterior: '',
  numeroInterior: '',
  codigoPostal: '',
  colonia: '',
  ciudad: '',
  estado: '',
  entreCalles: '',
  referencias: '',
};

const schema = yup.object().shape({
  nombre: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo')
    .max(100, 'Máximo'),
  telefono: yup.string().required('Requerido').length(10, 'Revisa lada'),
  delivery: yup.string().required('Requerido'),
  level: yup.string().required('Requerido'),
  access: yup.string().required('Requerido'),
  calle: yup.string().required('Requerido').min(3, 'Mínimo').max(100, 'Máximo'),
  numeroExterior: yup
    .string()
    .required('Requerido')
    .min(1, 'Mínimo')
    .max(10, 'Máximo'),
  numeroInterior: yup.string().min(1, 'Mínimo').max(10, 'Máximo'),
  codigoPostal: yup.string().required('Requerido').length(5, 'Revisar'),
  colonia: yup.string().required('Requerido'),
  ciudad: yup.string().required('Requerido'),
  estado: yup.string().required('Requerido'),
  entreCalles: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo')
    .max(100, 'Máximo'),
  referencias: yup.string().min(3, 'Mínimo').max(100, 'Máximo'),
});

export { schema, reset };
